import { lazy } from "react";
const SummaryComponent = lazy(
  () => import("./summaryComponent/SummaryComponent")
);
const TableComponent = lazy(
  () => import("./../../../components/tableComponent/TableComponent.js")
);
const VideosComponent = lazy(
  () => import("./videosComponent/FixtureVideosComponent")
);
const StatsComponent = lazy(() => import("./statsComponent/StatsComponent"));
const H2HComponent = lazy(() => import("./h2hComponent/H2HComponent"));
const LineupsComponent = lazy(
  () => import("./lineupsComponent/LineupsComponent")
);
const Components = {
  Table: TableComponent,
  Lineups: LineupsComponent,
  Summary: SummaryComponent,
  Stats: StatsComponent,
  H2H: H2HComponent,
  Videos: VideosComponent
};
export {
  Components
};
